import { Theme } from '@mui/material/styles';

export default function Link(_theme: Theme): object {
  return {
    MuiLink: {
      defaultProps: {
        underline: 'always',
      },
      styleOverrides: {
        underlineAlways: {
          textDecorationColor: _theme.palette.grey[600],
        },
      },
    },
  };
}
